import { render, staticRenderFns } from "./AlbumStatisticsV3.vue?vue&type=template&id=62b17da4&scoped=true"
import script from "./AlbumStatisticsV3.vue?vue&type=script&lang=js"
export * from "./AlbumStatisticsV3.vue?vue&type=script&lang=js"
import style0 from "./AlbumStatisticsV3.vue?vue&type=style&index=0&id=62b17da4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b17da4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b17da4')) {
      api.createRecord('62b17da4', component.options)
    } else {
      api.reload('62b17da4', component.options)
    }
    module.hot.accept("./AlbumStatisticsV3.vue?vue&type=template&id=62b17da4&scoped=true", function () {
      api.rerender('62b17da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/v3/AlbumStatisticsV3.vue"
export default component.exports